import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getInvoices(params: any): AxiosPromise {
    return EndPointService.get('/invoices', { params });
}
function getInvoicesSmall(params: any): AxiosPromise {
    return EndPointService.get('/invoices-simply-list', { params });
}
function getInvoicesDocs(params: any): AxiosPromise {
    return EndPointService.get('/invoice_docs', { params });
}
function declineInvoiceDoc(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/invoice-docs/decline/${id}`, { ...payload });
}
function approveInvoiceDoc(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/invoice-docs/approve/${id}`, { ...payload });
}

function getInvoice(id: number | string): AxiosPromise {
    return EndPointService.get(`/invoices/${id}`);
}

function deleteInvoice(id: number | string): AxiosPromise {
    return EndPointService.delete(`/invoices/${id}`);
}

function createInvoice(payload: any): AxiosPromise {
    return EndPointService.post('/invoices', payload);
}

function createInvoiceCase(payload: any): AxiosPromise {
    return EndPointService.put(`/occasions/invoice/${payload.id}`, payload);
}
function signInvoiceDoc(payload: any): AxiosPromise {
    return EndPointService.post(`/invoice-docs/signed-doc`, payload.formData, {
        params: { id: payload.id },
    });
}

function deleteFileInvoice(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/invoice_docs/${fileId}`);
}

function createFilesInvoice(data: any): AxiosPromise {
    return EndPointService.post(`/invoice_docs`, data);
}

function getFilesInvoice(id: string | number): AxiosPromise {
    return EndPointService.get(`/invoice_docs`, {
        params: {
            'invoice.id': id,
        },
    });
}

function getSignersInvoice(id: string | number): AxiosPromise {
    return EndPointService.get(`/envelope_docusigns`, {
        params: {
            'invoice.id': id,
        },
    });
}

function updateInvoice(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/invoices/${id}`, { ...payload });
}

function notifySignerOnInvoice(id: number | string): AxiosPromise {
    return EndPointService.put(`/invoices/notify/${id}`, {});
}

function sentToDocusign(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/invoices/status-docusign/${id}`, { ...payload });
}

function sentToParent(id: number | string): AxiosPromise {
    return EndPointService.put(`/invoices/send-to-parent/${id}`, { id: id });
}

function saveInvoiceReason(id: number | string, reason: string, status: number): AxiosPromise {
    return EndPointService.put(`/invoices/save-invoice-reason/${id}`, { reason, status });
}

function saveInvoiceNote(id: number | string, note: string): AxiosPromise {
    return EndPointService.put(`/invoices/save-invoice-note/${id}`, { note });
}

function sentStatementToParent(id: number | string): AxiosPromise {
    return EndPointService.put(`/statements/send-to-parent/${id}`, { id: id });
}

export default {
    getInvoices,
    getInvoicesSmall,
    getInvoicesDocs,
    declineInvoiceDoc,
    approveInvoiceDoc,
    getFilesInvoice,
    createFilesInvoice,
    deleteFileInvoice,
    signInvoiceDoc,
    getInvoice,
    deleteInvoice,
    createInvoice,
    updateInvoice,
    createInvoiceCase,
    getSignersInvoice,
    notifySignerOnInvoice,
    sentToDocusign,
    sentToParent,
    sentStatementToParent,
    saveInvoiceReason,
    saveInvoiceNote,
};
